import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

// Get Flat Transfer Preview
export const getFlatTransferPreviewReq = (action) => {
    const { flatId, society_id } = action?.data || {};
    const url = apiEndpoints.GET_FLAT_TRANSFER_PREVIEW_API.replace(':flatId', flatId);
    const params = {};
    if (society_id) params.society_id = society_id;
    return axiosInstance.get(url, { params });
}

// Execute Flat Transfer
export const executeFlatTransferReq = (action) => {
    const payload = { ...(action?.data || {}) };
    const { flatId, society_id } = payload;
    delete payload.flatId;
    delete payload.onSuccess;

    const url = apiEndpoints.EXECUTE_FLAT_TRANSFER_API.replace(':flatId', flatId);
    const params = {};
    if (society_id) {
        params.society_id = society_id;
        delete payload.society_id;
    }
    return axiosInstance.post(url, payload, { params });
}

// Get Flat Transfer History
export const getFlatTransferHistoryReq = (action) => {
    const searchQuery = action?.data || {};
    const { flatId } = searchQuery;
    const url = apiEndpoints.GET_FLAT_TRANSFER_HISTORY_API.replace(':flatId', flatId);

    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    return axiosInstance.get(url, { params });
}

// Get Flat Transfer Detail
export const getFlatTransferDetailReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_FLAT_TRANSFER_DETAIL_API.replace(':id', id);
    return axiosInstance.get(url);
}

// Reverse Flat Transfer
export const reverseFlatTransferReq = (action) => {
    const payload = { ...(action?.data || {}) };
    const { id } = payload;
    delete payload.id;
    delete payload.onSuccess;

    const url = apiEndpoints.REVERSE_FLAT_TRANSFER_API.replace(':id', id);
    return axiosInstance.post(url, payload);
}

// Add Document to a Flat Transfer
export const addFlatTransferDocumentReq = (action) => {
    const payload = { ...(action?.data || {}) };
    const { id } = payload;
    delete payload.id;
    delete payload.onSuccess;

    const url = apiEndpoints.ADD_FLAT_TRANSFER_DOCUMENT_API.replace(':id', id);
    return axiosInstance.post(url, payload);
}
